var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"style1-wap",class:{
    must: _vm.fieldObj.required == 1,
    err: _vm.fieldObj.dirty && _vm.fieldObj.invalid
  }},[_c('div',{staticClass:"u-reg-desc",domProps:{"innerHTML":_vm._s(_vm.descHtmlContent)}})])}
var staticRenderFns = []

export { render, staticRenderFns }